// extracted by mini-css-extract-plugin
export var circle = "_3d-2";
export var icon = "_3d-a";
export var iconHighlight = "_3d-0";
export var lg = "_3d-8";
export var md = "_3d-7";
export var outline = "_3d-4";
export var sm = "_3d-6";
export var square = "_3d-1";
export var xl = "_3d-9";
export var xs = "_3d-5";
export var xxs = "_3d-3";